import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'
import { tw } from 'utils/classnames'

const baseCardVariants = cva(
  'flex flex-col gap-2 overflow-hidden rounded-lg border border-semantic-cards-border-color transition-shadow',
  {
    variants: {
      size: {
        sm: 'px-semantic-cards-padding-x-small py-semantic-cards-padding-y-small',
        md: 'px-semantic-cards-padding-x-medium py-semantic-cards-padding-y-medium',
      },
      appearance: {
        default: 'bg-semantic-cards-default-background-color',
        inverse: 'bg-semantic-cards-inverse-background-color',
      },
      interactive: {
        true: 'cursor-pointer hover:shadow-md active:shadow-none',
        false: '',
      },
    },
    defaultVariants: {
      size: 'md',
      appearance: 'default',
      interactive: false,
    },
  },
)

export interface BaseCardProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof baseCardVariants> {
  asChild?: boolean
}

const BaseCard = ({
  ref,
  className,
  size,
  appearance,
  interactive,
  asChild = false,
  ...props
}: BaseCardProps & {
  ref?: React.RefObject<HTMLDivElement | null>
}) => {
  const Comp = asChild ? Slot : 'div'

  return (
    <Comp
      className={tw(baseCardVariants({ size, appearance, interactive, className }))}
      tabIndex={interactive ? 0 : undefined}
      ref={ref}
      {...props}
    />
  )
}
BaseCard.displayName = 'BaseCard'

export { BaseCard, baseCardVariants }
